import AsyncStorage from "@react-native-async-storage/async-storage";
import { sendMessageToFrame, isWeb } from "../../utils/Helper";
import { loginAlliantsChat, logoutAlliantsChat } from "./alliantsChat";
import { ALLIANTS_CHAT, INNSPIRECHAT } from "../../config/Constant";
import { setChatInterface } from "../../Redux/Reducers/appPreservedConfigReducer";

export const chatLogin = () => async (dispatch, getState) => {
  try {
    const { chatInterface } = getState().appPreservedConfigSlice;

    const interfaceKey = chatInterface?.interfaceKey?.toLowerCase();

    if (interfaceKey === ALLIANTS_CHAT) {
      if (isWeb()) return;
      const alreadyInit = await AsyncStorage.getItem("alliantsChatLoginInit");
      if (alreadyInit === "true") {
        console.log("Alliants chat: already initialized, skipping login");
        return;
      }
      const loginSuccess = await dispatch(loginAlliantsChat());
      if (loginSuccess) {
        await AsyncStorage.setItem("alliantsChatLoginInit", "true");
      }
    }

    if (interfaceKey === INNSPIRECHAT) {
      // innspirechat login is handled in the InnspireChatBot component itself, so no action needed here
    }

  } catch (error) {
    console.log("chatLogin error:", error?.message);
  }
};


export const chatLogout = (innspireChatRef) => async (dispatch, getState) => {
  try {
    const { chatInterface } = getState().appPreservedConfigSlice;
    const interfaceKey = chatInterface?.interfaceKey?.toLowerCase();

    if (interfaceKey === ALLIANTS_CHAT) {
      console.log("Alliants: attempting logged out");
      dispatch(setChatInterface({ showConversation: false }));
      await AsyncStorage.removeItem("alliantsChatLoginInit");
      await dispatch(logoutAlliantsChat());
    }

    if (interfaceKey === INNSPIRECHAT) {
      dispatch(setChatInterface({ showConversation: false }));
      await AsyncStorage.removeItem("innSpireChatLoginInit");
      if (innspireChatRef?.current) {
        sendMessageToFrame(innspireChatRef, { type: "INNSPIRECHAT_LOGOUT" });
      }
    }
  } catch (error) {
    console.log("chatLogout error:", error?.message);
  }
};
